import { KpiCard } from './KpiCard';
import { AttentionCard } from './AttentionCard';
import { QuickAccessCard } from './QuickAccessCard';
import { useDashboard } from './useDashboard';

/**
 * Cuadro de mando. KPIs come from GET /api/dashboard via TanStack Query.
 * While loading (or if the backend is empty) the cards keep their exact
 * geometry and show a skeleton / em-dash — no layout shift on data arrival.
 */
export function DashboardScreen() {
  const { data, isLoading } = useDashboard();
  const k = data?.kpis;

  return (
    <div className="min-h-full bg-s-bg p-[22px] text-s-text">
      {/* KPI grid */}
      <div className="mb-[16px] grid grid-cols-4 gap-[14px]">
        <KpiCard
          label="Avisos hoy"
          loading={isLoading}
          value={k ? String(k.avisosHoy) : undefined}
          sub={k ? `${k.avisosAccion} requieren acción` : undefined}
        />
        <KpiCard
          label="T. medio respuesta"
          loading={isLoading}
          value={k?.tiempoRespuesta}
          sub={k ? 'objetivo < 8:00' : undefined}
        />
        <KpiCard
          label="Ambulancias libres"
          loading={isLoading}
          value={k?.ambulanciasLibres}
          sub={k?.ambulanciasDetalle}
        />
        <KpiCard
          label="Sin recurso"
          loading={isLoading}
          critical
          value={k ? String(k.sinRecurso) : undefined}
          sub={k?.sinRecursoDetalle}
        />
      </div>

      {/* lower row */}
      <div className="grid grid-cols-[1.4fr_1fr] gap-[14px]">
        <AttentionCard />
        <QuickAccessCard />
      </div>
    </div>
  );
}
